<mbs-modal
  #modal
  [isCustomModal]="true"
  [loading]="false"
  [showFooter]="true"
  [title]="'wizards:onboarding.installationModeStep.modalTitle' | i18next">
  <ng-container
    modal-body
    [formGroup]="form">
    <mbs-form-group formGroupName="filter">
      <div class="mb-3 row">
        @if (!hiddenElements.companySelect) {
          <div class="col">
            <mbs-company-select
              formControlName="companies"
              [multiple]="true"
              [placeholder]="'shared:common.company' | i18next: { format: 'title' }"
              [selectedIds]="preSelectedCompanyIds">
            </mbs-company-select>
          </div>
        }
        @if (!hiddenElements.osSelect) {
          <div class="col">
            <mbs-select
              bindLabel="name"
              formControlName="os"
              [clearable]="true"
              [isCheckboxOverflow]="true"
              [isCheckboxSelect]="true"
              [items]="osTypes"
              [multiple]="true"
              [placeholder]="'shared:placeholders.selectOS' | i18next"
              [searchable]="false"
              [showRequiredMark]="false">
            </mbs-select>
          </div>
        }
      </div>
      <div class="mb-3 row">
        <div class="col">
          <mbs-input
            formControlName="search"
            [appendButtons]="[{ type: 'secondary', icon: 'ico ico-Search' }]"
            [clearButton]="true"
            [placeholder]="'shared:placeholders.search' | i18next"
            (buttonClick)="handleSearch()">
          </mbs-input>
        </div>
      </div>
    </mbs-form-group>
    <mbs-computer-list-select
      formControlName="computers"
      [computersNotFound]="computersNotFound"
      [excludeItem]="data?.excludeItem"
      [filter]="computedFilters()"
      [multipleSelect]="multipleSelect"
      [notSetResult]="notSetResult"
      [showComputerDetails]="data?.showComputerDetails"
      [showSelectedCounter]="multipleSelect">
    </mbs-computer-list-select>
  </ng-container>
  <ng-container modalFooter>
    <div class="d-flex align-items-center justify-content-between w-100">
      <div class="d-flex align-items-center">
        @if (showBetaFeatureRequest()) {
          <mbs-beta-feature-request
            [buildName]="data.betaFeatureBuildName"
            [featureName]="data.betaFeatureName"
            [version]="data.betaFeatureVersion"></mbs-beta-feature-request>
        }
      </div>
      <div class="d-flex align-items-center">
        <mbs-button
          [type]="'primary'"
          (click)="handleSave()">
          {{ data?.saveText || ('shared:buttons.save' | i18next) }}
        </mbs-button>
        <mbs-button
          class="ml-2"
          data-dismiss="modal"
          [type]="'secondary'"
          (click)="handleCancel()">
          {{ 'shared:buttons.cancel' | i18next }}
        </mbs-button>
      </div>
    </div>
  </ng-container>
</mbs-modal>
